<template #anchor>
  <RouterLink to="/cart" aria-label="Shopping cart">
    <VaButton v-if="cart.length > 0" preset="secondary" color="textPrimary">
      <VaBadge overlap>
        <template #text>{{ cart.length }}</template>
        <VaIcon name="shopping_cart" />
      </VaBadge>
    </VaButton>
  </RouterLink>
</template>
<script setup lang="ts">
import { useCart } from '@/pages/cart/composables/useCart'

const { cart } = useCart()
</script>

<style lang="scss" scoped></style>
